<template>
  <div
    v-loading.fullscreen.lock="isSubmitting"
    :element-loading-text="$t('Submitting...')"
    class="biller-page company-edit-form-page page-content">
    <el-row class="page-header -with-back-button" type="flex" justify="space-between">
      <el-col :span="24">
        <el-button type="text"
                   icon="el-icon-back"
                   class="back-button"
                   @click.prevent="goBack">
        </el-button>
        <h2 class="page-title">แก้ไขรายละเอียดบริษัท</h2>
      </el-col>
    </el-row>

    <el-form
      :model="companyForm"
      :rules="companyFormRules"
      ref="companyForm"
      label-width="120px"
      label-position="top"
      @submit.native.prevent="submitForm('companyForm')"
      :disabled="isSubmitting"
      v-if="company"
      class="company-form company-detail-info">
      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">รายละเอียดบริษัท</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="24" class="label">
              ชื่อบริษัท
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              {{ company.name }}
              <br/><br/>
            </el-col>
          </el-row>
          <el-row class="logo-uploader-holder">
            <el-col :span="24">
              <el-form-item label="โลโก้บริษัท" prop="logo">
                <div class="logo-holder" v-if="companyForm.logo">
                  <img :src="companyForm.logo" class="logo"/>
                </div>
                <el-upload
                  class="company-logo-uploader"
                  :action="uploadUrl"
                  drag
                  :show-file-list="false"
                  :http-request="handleHttpRequest"
                  :on-success="handleLogoSuccess"
                  :on-error="handleLogoFail"
                  :before-upload="beforeLogoUpload">
                  <div class="upload-instruction" v-loading="isUploading">
                    <h3>อัพโหลดโลโก้บริษัท</h3>
                    <i class="el-icon-upload logo-uploader-icon"></i>
                  </div>
                </el-upload>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  @click="removeLogo"
                  v-if="companyForm.logo"
                  class="remove-logo">ลบโลโก้บริษัท</el-button>
                <div class="upload-instruction-hint">
                  ขนาดขั้นต่ำ 500px x 500px และต้องเป็นไฟล์นามสกุล JPG, PNG, GIF
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ที่อยู่หลักของบริษัท</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="ที่อยู่" prop="address.line_1">
                <el-input
                  v-model="companyForm.address.line_1"
                  id="companyForm.address.line_1"
                  placeholder="กรอกที่อยู่"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="ตำบล/แขวง" prop="address.district">
                <el-input
                  v-model="companyForm.address.district"
                  id="companyForm.address.district"
                  placeholder="กรอกตำบล/แขวง"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-form-item label="อำเภอ/เขต" prop="address.city">
                <el-input
                  v-model="companyForm.address.city"
                  id="companyForm.address.city"
                  placeholder="กรอกอำเภอ/เขต"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="จังหวัด" prop="address.province">
                <el-select
                  v-model="companyForm.address.province"
                  id="companyForm.address.province">
                  <el-option
                    v-for="province in provinceList"
                    :key="province"
                    :label="province"
                    :value="province">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-form-item label="รหัสไปรษณีย์" prop="address.postal_code">
                <el-input
                  v-model="companyForm.address.postal_code"
                  id="companyForm.address.postal_code"
                  @change="updatePostCode"
                  ref="companyForm.address.postal_code"
                  @input.native="handleInput($event, 'companyForm.address.postal_code', 'postcode')"
                  placeholder="กรอกรหัสไปรษณีย์"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="โทรศัพท์" prop="address.tel">
                <el-input
                  v-model="companyForm.address.tel"
                  id="companyForm.address.tel"
                  placeholder="กรอกโทรศัพท์"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-form-item label="โทรสาร" prop="address.fax">
                <el-input
                  v-model="companyForm.address.fax"
                  id="companyForm.address.fax"
                  placeholder="กรอกโทรสาร"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="21">
              <el-form-item class="button-bar">
                <el-button
                  type="primary"
                  plain
                  class="cancel-btn"
                  @click="goBack"
                  id="companyForm.cancelButton">{{ 'Cancel' | translate }}</el-button>
                <div class="submit-button-group">
                  <el-button
                    type="primary"
                    id="companyForm.submitButton"
                    icon="el-icon-edit"
                    native-type="submit">{{ 'Save and continue' | translate }}</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  /* eslint no-param-reassign: 0 */
  import helpers from '@/libs/helpers';
  import { createMask } from 'imask';
  import _ from 'lodash';
  // import XRegExp from 'xregexp';

  const BillerUserListView = {
    name: 'biller-company-edit',
    data() {
      return {
        isSubmitting: false,
        isUploading: false,
        companyForm: {
          id: null,
          tax_id: '',
          slug: '',
          name: '',
          name_on_payment_card: '',
          logo: '',
          // tel: '',
          // fax: '',
          address: {
            line_1: '',
            district: '',
            city: '',
            province: '',
            postal_code: '',
            tel: '',
            fax: '',
          },
          profiles_count: 0,
        },
        companyFormRules: {
          /* logo: [
            { required: true, message: 'กรุณาเลือกโลโก้บริษัท', trigger: 'blur' },
          ], */
          'address.line_1': [
            { required: true, message: 'กรุณากรอกที่อยู่บริษัท', trigger: 'blur' },
          ],
          'address.district': [
            { required: true, message: 'กรุณากรอกตำบล/แขวง', trigger: 'blur' },
          ],
          'address.city': [
            { required: true, message: 'กรุณากรอกอำเภอ/เขต', trigger: 'blur' },
          ],
          'address.province': [
            { required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'blur' },
          ],
          'address.postal_code': [
            { required: true, min: 5, message: 'กรุณากรอกรหัสไปรษณีย์ให้ถูกต้อง', trigger: 'blur' },
          ],
          'address.tel': [
            { required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' },
            // { type: 'string',
            // pattern: new XRegExp('^02-\\d{3}-\\d{4}$|^0[3-5|7]\\d{1}-\\d{3}-\\d{3}$|^0[6|8|9]
            // \\d{1}-\\d{3}-\\d{4}$', 'g'),
            // message: 'กรุณากรอกหมายเลขโทรศัพท์ให้ตรงรูปแบบ', trigger: 'blur' },
          ],
          'address.fax': [
            { message: 'กรุณากรอกหมายเลขโทรสาร', trigger: 'blur' },
            // { type: 'string',
            // pattern: new XRegExp('^02-\\d{3}-\\d{4}$|^0[3-5|7]\\d{1}-\\d{3}-\\d{3}$', 'g'),
            // message: 'กรุณากรอกหมายเลขโทรสารให้ตรงรูปแบบ', trigger: 'blur' },
          ],
        },
        mask: {
          postcode: {
            mask: '00000',
          },
          telMask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
            { mask: '{0}00-000-0000' },
          ],
          faxMask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
          ],
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      company() {
        return this.$store.getters.billerInfo;
      },
      uploadUrl() {
        return `${process.env.CLOUDINARY_API_BASE_URL}${window.appConfig.CLOUDINARY_CLOUD_NAME}/upload`;
      },
      provinceList() {
        return helpers.getProvinceList();
      },
      baseHost() {
        return helpers.getCurrentBaseHost();
        // return window.appConfig.BASE_HOST;
      },
    },
    methods: {
      goBack() {
        this.$router.push({ name: 'BillerCompanyDetail' });
      },
      handleLogoSuccess(res) {
        this.isUploading = false;
        if (res.secure_url) {
          this.companyForm.logo = res.secure_url;
        }
      },
      handleLogoFail(res) {
        this.isUploading = false;
        let errorMessage = this.$t('Unexpected error');
        if (res) {
          errorMessage = res;
          if (res.error) {
            errorMessage = res.error;
            if (res.error.message) {
              errorMessage = res.error.message;
            }
          }
        }
        this.$store.dispatch('ADD_ERROR_FLASH', errorMessage);
      },
      beforeLogoUpload(file) {
        const isImage = ['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) !== -1;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isImage) {
          this.$message.error('Logo picture must be JPG, PNG or GIF format!');
        }
        if (!isLt2M) {
          this.$message.error('Logo picture size can not exceed 2MB!');
        }
        return isImage && isLt2M;
      },
      handleHttpRequest(options) {
        this.isUploading = true;
        return this.$store.dispatch('UPLOAD_BILLER_COMPANY_LOGO', options.file);
      },
      removeLogo() {
        this.$confirm('คุณต้องการยืนยันการลบโลโก้บริษัทออกใช่หรือไม่?', 'ยืนยันการลบโลโก้บริษัท', {
          confirmButtonText: 'ยืนยันการลบ',
          confirmButtonClass: 'danger-btn',
          cancelButtonText: 'ยกเลิก',
          type: 'warning',
        }).then(() => {
          this.companyForm.logo = '';
        }).catch(() => {
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate(this.validateForm);
      },
      validateForm(valid) {
        if (!valid) {
          this.$log.error('error submit!!');
          return false;
        }
        this.isSubmitting = true;
        const payload = JSON.parse(JSON.stringify(this.companyForm));
        this.$store.dispatch('UPDATE_BILLER_COMPANY_INFO', payload).then(() => {
          this.isSubmitting = false;
          this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'แก้ไขข้อมูลบริษัทสำเร็จแล้ว',
          });
          this.$nextTick(() => {
            this.goBack();
          });
        }).catch((msg) => {
          this.isSubmitting = false;
          if (msg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
        return true;
      },
      /* updateMaskTel() {
        this.maskValue(this.companyForm.address, 'tel', {
          mask: this.mask.telMask,
        });
      },
      updateMaskFax() {
        this.maskValue(this.companyForm.address, 'fax', {
          mask: this.mask.faxMask,
        });
      }, */
      updatePostCode() {
        try {
          this.maskValue(this.companyForm.address, 'postal_code', this.mask.postcode);
        } catch (e) {
          console.error(e);
        }
      },
      maskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          const resolvedValue = mask.resolve(val.toString());
          form[field] = resolvedValue;
        }
      },
      unmaskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          mask.resolve(val.toString());
          form[field] = mask.unmaskedValue;
        }
      },
      /* eslint prefer-arrow-callback: 0 */
      handleInput: _.debounce(function handleInputFn(evt, refName, maskName) {
        helpers.handleInput(evt,
          this.$refs, refName,
          this.mask, maskName);
      }, process.env.HANDLE_INPUT_DEBOUNCE_INTERVAL, { tailing: true }),
    },
    mounted() {
      // load data to form
      if (this.isUpdated) {
        setTimeout(() => {
          if (typeof this.company === 'undefined' || this.company === null) {
            this.goBack();
          }
        }, 1000);
      }
      this.$nextTick(() => {
        Object.keys(this.company).forEach((key) => {
          if (key === 'address') {
            Object.keys(this.company.address).forEach((addrKey) => {
              this.$set(this.companyForm.address, addrKey, this.company.address[addrKey]);
            });
          } else {
            this.$set(this.companyForm, key, this.company[key]);
          }
        });
        this.updatePostCode();
      });
    },
  };
  export default BillerUserListView;
</script>

<style lang="scss">
  .biller-page {
    &.company-edit-form-page {
      .el-select {
        width: 100%;
      }
      .submit-button-group {
        float: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/biller/company-edit.vue